module.exports = __webpack_public_path__ + "static/media/tarot-card-14.56776795.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/tarotcards/tarot-card-14.jpg
// module id = 1547
// module chunks = 0